const permanentKeys = ["locationId", "configId", "partnerToken", "partnerCode"] as const;
const sessionKeys = ["sessionId"] as const;

import { getSearchParam, type SearchParamsSource } from "@/utils/searchParams";

type PermanentParamKeys = (typeof permanentKeys)[number];
type SessionParamKeys = (typeof sessionKeys)[number];

type QueryParamsType = Partial<Record<PermanentParamKeys | SessionParamKeys, string | undefined>>;

interface FilterOptions {
	includeSession?: boolean;
}

export function parseQueryParams(search: SearchParamsSource, options: FilterOptions = {}): QueryParamsType {
	const { includeSession = true } = options;

	return Object.fromEntries(
		[...permanentKeys, ...(includeSession ? sessionKeys : [])]
			.map((key) => [key, getSearchParam(search, key)])
			.filter(([, value]) => value !== undefined),
	);
}
